import React, { useState } from "react";
import { ReactComponent as LogoFull } from "../../assets/logo_full.svg";
import CustomInput from "../../../src/components/CustomInput";
import ButtonSave from "../../../src/components/ButtomSave";
import PaymentStatus from "../../../src/components/PaymanetStatus";
import axios from "axios";
import { toast } from "sonner";
import { useStore } from "../../lib/store";
import { AmplitudeLog } from "../../lib/amplitude";

const RegisterApp: React.FC = () => {
  const [loading, set_loading] = useState(false);
  const { set_sync_checkout } = useStore();

  const [emailValue, setEmailValue] = useState("");
  const [errorEmailValue, setErrorEmailValue] = useState("");

  const [nameValue, setNameValue] = useState("");
  const [errorNameValue, setErrorNameValue] = useState("");

  const { id_pedido } = useStore();
  const { id_negocio } = useStore();

  const [registerError, setRegisterError] = useState(false);

  const saveEmailRegister = async () => {
    AmplitudeLog("email_checkout", { email: emailValue });
    set_loading(true);
    try {
      const resposta = await axios.post(
        "https://n8n.kinology.com.br/webhook/create_app_checkout",
        {
          "email": emailValue,
          "nome": nameValue,
          "id_negocio": id_negocio,
          "id_pedido": id_pedido
        },
        {
          headers: {
            "Content-Type": "application/json",
            n8n_token: "81lnrDr5uwvIM3IjGj3vW4r",
          },
        }
      );

      if (resposta.data.status_code === 200) {
        set_loading(false);
        set_sync_checkout(true);
      } else {
        AmplitudeLog("erro_email_cadastrado_checkout");
        toast(resposta.data.status_code + ": " + resposta.data.msg, {
          action: {
            label: "X",
            onClick: () => console.log("Undo"),
          },
          className: "!bg-red-dark !text-white-primary",
        });
        set_loading(false);
      }
    } catch (erro: any) {
      toast("Erro ao cadastrar: Exception Error", {
        action: {
          label: "X",
          onClick: () => console.log("Undo"),
        },
        className: "!bg-red-dark !text-white-primary",
      });
      set_loading(false);
    }
  };

  const verifyError = () => {
    if (
      emailValue === "" ||
      errorEmailValue !== "" ||
      nameValue === "" ||
      errorNameValue !== ""
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="flex flex-col justify-between h-[100%]">
      <p></p>
      <div className="w-[100%] flex flex-col items-center">
        <LogoFull className="w-[10rem] h-[2.1rem]" />
        <p className="text-blue-primary mt-[1.25rem] text-[1.2rem] font-[700]">
          Seja bem-vindo(a)
        </p>
        <p className="text-center mt-[1.88rem] mb-[2.7rem]">
          Insira um <strong>nome e e-mail</strong> abaixo que será utilizado
          para realizar o login no nosso aplicativo.
        </p>
        <div className="flex flex-col w-[100%] gap-y-[1rem]">
          <CustomInput
            icon="name"
            title="Nome completo"
            placeholder="Nome completo"
            type="card_name"
            value={nameValue}
            onChange={setNameValue}
            error={errorNameValue}
            onError={setErrorNameValue}
            required
          />
          <CustomInput
            icon="email"
            title="E-mail"
            placeholder="E-mail"
            type="email"
            value={emailValue}
            onChange={setEmailValue}
            error={errorEmailValue}
            onError={setErrorEmailValue}
            required
          />
        </div>
        <div className="w-[100%]">
          <p className="text-[0.7rem] mt-[0.5rem]">
            Você receberá neste mesmo endereço o link para redefinição da sua
            senha.
          </p>
        </div>
      </div>
      <ButtonSave
        icon="none"
        theme={"blue"}
        loading={loading}
        className={`${verifyError() && "opacity-25"}`}
        onClick={verifyError() ? () => { } : saveEmailRegister}
      >
        Confirmar
      </ButtonSave>
      <PaymentStatus
        icon={"error"}
        legend={
          "Verificamos que este e-mail já está em uso na nossa plataforma. Por favor, tente outro e-mail para realizar o login."
        }
        open={registerError}
        close={() => setRegisterError(false)}
        title={"E-mail já cadastrado"}
      />
    </div>
  );
};

export default RegisterApp;
